import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';

const propTypes = {
  details: PropTypes.shape({
    airline_name: PropTypes.string,
    airline_code: PropTypes.string,
    pnr_code: PropTypes.string,
    pax_name: PropTypes.string,
  }),
  plan: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
};

const defaultProps = {
  details: {},
  plan: {},
};

class PolicyDetailsBaggageBRB extends PureComponent {
  render() {
    const {
      details,
      plan,
    } = this.props;

    return (
      <div>
        <CardSectionHeading>
          Flight Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Airline"
          detail={`${details.airline_name} (${details.airline_code})`}
        />
        <CardRowKeyVal
          title="Confirmation #"
          detail={details.pnr_code}
        />
        <CardRowKeyVal
          title="Passenger"
          detail={details.pax_name}
        />
        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Plan type"
          detail={plan.title}
        />
        <CardRowKeyVal
          title="Coverage"
          detail={plan.subtitle}
        />
      </div>
    );
  }
}

PolicyDetailsBaggageBRB.propTypes = propTypes;
PolicyDetailsBaggageBRB.defaultProps = defaultProps;

export default PolicyDetailsBaggageBRB;
